import { defineComponent } from 'vue';
import { LoginFormVue } from '@/common/primary/auth/login-form';

export default defineComponent({
  name: 'LoginPage',

  components: { LoginFormVue },
});
